import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

const mutation = gql`
  mutation facilityCreate($attributes: CreateFacilityAttributesInput!) {
    facilityCreate(attributes: $attributes) {
      id
      confirmed_at
    }
  }
`

export default function useFacilityCreate() {
  const { onMutate: onFacilityCreate, loading } = useSafeRunMutation({
    mutation,
    responsePath: 'facilityCreate',
    successMessage: 'Facility created'
  })

  return { onFacilityCreate, loading }
}
